export default "/images/vendor/@coreui/icons/svg/flag/cif-mw.svg?f504dafe2834da427ed6670dfeee1f15";